import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../../shared';

import {
    ApplicationArtatechService,
    ApplicationArtatechPopupService,
    ApplicationArtatechComponent,
    ApplicationArtatechDetailComponent,
    ApplicationArtatechDialogComponent,
    ApplicationArtatechPopupComponent,
    ApplicationArtatechDeletePopupComponent,
    ApplicationArtatechDeleteDialogComponent,
    applicationRoute,
    applicationPopupRoute,
} from './';

let ENTITY_STATES = [
    ...applicationRoute,
    ...applicationPopupRoute,
];

@NgModule({
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ApplicationArtatechComponent,
        ApplicationArtatechDetailComponent,
        ApplicationArtatechDialogComponent,
        ApplicationArtatechDeleteDialogComponent,
        ApplicationArtatechPopupComponent,
        ApplicationArtatechDeletePopupComponent,
    ],
    entryComponents: [
        ApplicationArtatechComponent,
        ApplicationArtatechDialogComponent,
        ApplicationArtatechPopupComponent,
        ApplicationArtatechDeleteDialogComponent,
        ApplicationArtatechDeletePopupComponent,
    ],
    providers: [
        ApplicationArtatechService,
        ApplicationArtatechPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceApplicationArtatechModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech.module.ts